import React from 'react'
import Header from '../../components/Header'
import Hero from '../../components/Hero'

function Home() {
  return (
    <>
      <Header
        title="Blog | Ndolet Corp."
        description="Ndolet Consulting Corp. Blog Platform" />
      <Hero />
    </>
  )
}

export default Home